import { render, staticRenderFns } from "./Question15.vue?vue&type=template&id=04b74b68&scoped=true&"
import script from "./Question15.vue?vue&type=script&lang=js&"
export * from "./Question15.vue?vue&type=script&lang=js&"
import style0 from "./Question15.vue?vue&type=style&index=0&id=04b74b68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b74b68",
  null
  
)

export default component.exports